resourcePaths = '{"rootPath":"","assetsPath":""}';/*
    Validation

    mogo-ui-lib component that forms the validation framework to be used across all forms.

    Arguments:
        validationObj (required) [object]:
            Validation object consisting of field names, conditionals, assertions,
            sanitize functions, and error strings. See below for format.
        callback (optional) [function]:
            Callback function to be called on submit of the form. Callback function will pass
            a boolean result and an event, if applicable.
        onUpdateValidation (optional) [function]:
            Callback function to be called on validation of any field. Callback function will
            pass the formId and the result object of the form.
        objectName (optional) [string]:
            Used for FS back-end validation only. The name of the back-end object being validated.

    validationObj [object] format:
    {
        <field_name>: {
            [sanitize (function)],
            [conditional (function)],
            [error (string | object)],
            assertion (array of Assert) | assertions (array of assertionObj)
        }
    }

    assertionObj [object] format:
    {
        [sanitize (function)],
        [conditional (function)],
        [error (string | object)],
        assertion (array of Assert)
    }

    errorObj [object] format:
    {
        [default (string)],
        key_name (string)
    }
*/
function Validation () {
  this.priority = 1900;
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this.objectName = null;
  this.validationObj = null;
  this.callback = null;
  this.onUpdateValidation = function (formId, results) {};
  this.dlAbandonedFields = [];

  this.analyticsEvents = {
    'form-errors': {
      FormErrors: function (errorFieldList) {
        return errorFieldList;
      },
      event: 'DLevent.FormErrors'
    },
    'form-abandoned': {
      FormAbandoned: function (fieldsInteractedWith) {
        return fieldsInteractedWith;
      },
      event: 'DLevent.FormExit'
    }
  };
  this.analytics = new Analytics();
  this.analytics.extendEventObject(this.analyticsEvents);

  this._resultObj = new Object();

  this.init = function () {
    $(this.node).css('display', 'block');

    // Submit event handler
    if (
      $(this.node)
        .prop('tagName')
        .toLowerCase() == 'form' &&
      this.validationObj != null
    ) {
      $(this.node).on('submit', $.proxy(this.validate, this));
    }

    // Init result object
    this._resultObj['submitted'] = false;
    this._resultObj['resultObj'] = new Object();
    this._resultObj['count'] = 0;
    this._resultObj['currentError'] = null;
  };

  this.initAllReady = function () {
    // Create result object and connect field event handlers
    this._initializeResultObjectAndConnections();

    // DL Abandoned Form Report
    $(window).on('beforeunload.validation', this._onFormAbandonment.bind(this));

    // Check if there are back-end form errors (for FS)
    if (mogo.registry.errorState == null || !mogo.registry.errorState) return;

    // Process back-end form errors (for FS)
    var efa = mogo.registry.errorFieldArray;
    if (efa != null && efa.length > 0) {
      this._resultObj.submitted = true;
      for (var i = 0; i < efa.length; i++) {
        var fieldName = '';
        if (this.objectName != null && this.objectName != '') {
          fieldName = this.objectName + '[' + efa[i] + ']';
        } else {
          fieldName = efa[i];
        }
        this._showFieldError(fieldName);
      }
      this._refreshErrorObj();

      if (this._resultObj.count > 0) {
        this._scrollTo(this._resultObj.currentError);
        this.onUpdateValidation(this.id, this._resultObj);
      }
    }

    // Validation callback
    if (this.callback != null && typeof this.callback === 'function') this.callback(false);
  };

  // Returns an array without duplicate items
  // Prop of Fields array: [pos, title]
  this.distinctArray = function (fields) {
    var temp = [];
    var result = fields.filter(function (value, index, self) {
        // if the value (converted to string) is not found
        // in temp then return value.
      if (temp.indexOf(value.toString()) < 0) {
        temp.push(value.toString());
        return value;
      }
    });
    return result;
  };

  // For new APIRequest - pass error object from APIRequest response
  this.parseErrorObject = function (errorObj) {
    this._resultObj.submitted = true;
    for (var i = 0; i < errorObj.length; i++) {
      var err = errorObj[i];
      var key = err.key;
      if (key == null) key = 'default';

      // Reset error message for field
      $("[name='" + err.property + "']", this.node)
        .mogo()
        .setError(true);

      // Attempt to find error string based on key
      var found = false;
      var fieldValidationObj = this.validationObj[err.property];

      // Check assertions object
      if (fieldValidationObj.assertions != null) {
        for (var j = 0; j < fieldValidationObj.assertions.length; j++) {
          if (
            fieldValidationObj.assertions[j].error != null &&
            typeof fieldValidationObj.assertions[j].error === 'object' &&
            fieldValidationObj.assertions[j].error[key] != undefined
          ) {
            $("[name='" + err.property + "']", this.node)
              .mogo()
              .setError(true, fieldValidationObj.assertions[j].error[key]);
            found = true;
            break;
          }
        }
      }

      // Check error object on root level
      if (!found) {
        if (fieldValidationObj.error != null) {
          if (typeof fieldValidationObj.error === 'string') {
            $("[name='" + err.property + "']", this.node)
              .mogo()
              .setError(true, fieldValidationObj.error);
          } else if (typeof fieldValidationObj.error === 'object') {
            if (fieldValidationObj.error[key] != null) {
              $("[name='" + err.property + "']", this.node)
                .mogo()
                .setError(true, fieldValidationObj.error[key]);
            }
          }
        }
      }

      this._showFieldError(err.property);
    }
    this._refreshErrorObj();

    if (this._resultObj.count > 0) {
      this._scrollTo(this._resultObj.currentError);
      this.onUpdateValidation(this.id, this._resultObj);
    }
  };

  this.validate = function (evt) {
    if (evt) evt.preventDefault();
    this._resultObj.currentError = null;
    this._resultObj.submitted = true;
    for (var name in this.validationObj) {
      if (!$("[name='" + name + "']", this.node).length == 0) {
        this._runValidationForField(name);
      }
    }
    this._refreshErrorObj();

    var result = true;
    for (var key in this._resultObj.resultObj) {
      var obj = this._resultObj.resultObj[key];
      if (!this._toggleErrorState(obj)) {
        result = false;
      }
    }

    var callbackResult = null;
    if (this.callback != null && typeof this.callback === 'function') {
      callbackResult = this.callback(result, evt);
    }

    if (this._resultObj.currentError != null) {
      this._scrollTo(this._resultObj.currentError);
    }

    this.onUpdateValidation(this.id, this._resultObj);

    if (callbackResult != undefined && callbackResult != null) return callbackResult;
    else return result;
  };

  this.runPartialValidation = function (fieldArr, quiet, enableAnalytics) {
    if (typeof enableAnalytics === 'undefined') enableAnalytics = false;
    if (quiet != null && quiet == true) {
      var currentStateObj = jQuery.extend(true, {}, this._resultObj);
      for (var i = 0; i < fieldArr.length; i++) {
        var name = fieldArr[i];
        if ($("[name='" + name + "']", this.node).length != 0) {
          this._runValidationForField(name);
        }
      }
      this._refreshErrorObj(enableAnalytics);
      var result = true;
      for (var i = 0; i < fieldArr.length; i++) {
        var name = fieldArr[i];
        var obj = this._resultObj.resultObj[name];
        if (!obj.result) result = false;
      }
      this._resultObj = currentStateObj;
      return result;
    } else {
      this._resultObj.currentError = null;
      this._resultObj.count = 0;
      this._resultObj.submitted = true;
      for (var i = 0; i < fieldArr.length; i++) {
        var name = fieldArr[i];
        if ($("[name='" + name + "']", this.node).length != 0) {
          this._runValidationForField(name);
        }
      }
      this._refreshErrorObj(enableAnalytics);

      var result = true;
      for (var i = 0; i < fieldArr.length; i++) {
        var name = fieldArr[i];
        var obj = this._resultObj.resultObj[name];
        if (!this._toggleErrorState(obj)) {
          result = false;
        }
      }

      if (this._resultObj.currentError != null) {
        this._scrollTo(this._resultObj.currentError);
      }
      this.onUpdateValidation(this.id, this._resultObj);

      return result;
    }
  };

  /*
        Clears the validation error from the results object and from the UI for fields without values (used for conditionally required fields)
    */

  this.clearValidationForFields = function (fieldArr) {
    for (var i = 0; i < fieldArr.length; i++) {
      if (
        ($("[name='" + fieldArr[i] + "']", this.node).mogo().declaredClass == 'Checkbox' &&
          !$("[name='" + fieldArr[i] + "']", this.node).mogo().checked) ||
        ($("[name='" + fieldArr[i] + "']", this.node).mogo().declaredClass == 'Radio' &&
          !$("[name='" + fieldArr[i] + "']", this.node).mogo().checked) ||
        !$("[name='" + fieldArr[i] + "']", this.node).val()
      ) {
        delete this._resultObj.resultObj[fieldArr[i]].errorDetails;
        this._resultObj.resultObj[fieldArr[i]].result = true;

        var fieldObj = this._resultObj.resultObj[fieldArr[i]];
        this._toggleErrorState(fieldObj);

        this.onUpdateValidation(this.id, this._resultObj);
      }
    }
  };

  /*
        Creates result object from validationObj and connects field event handlers
    */
  this._initializeResultObjectAndConnections = function () {
    // Fix validation object
    var fixArray = new Array();
    for (var name in this.validationObj) {
      if ($("[name='" + name + "']", this.node).length == 0) {
        if ($("[id='" + name + "']", this.node).length == 0) {
          console.warn(name + ' does not exist');
        } else {
          var from = name;
          var to = $("[id='" + name + "']", this.node)
            .first()
            .attr('name');
          if (to == null) {
            to = from;
            $("[id='" + name + "']", this.node)
              .first()
              .attr('name', to);
          } else {
            fixArray.push({from: from, to: to});
          }
        }
      }
    }
    for (var i = 0; i < fixArray.length; i++) {
      var curFix = fixArray[i];
      this.validationObj[curFix.to] = this.validationObj[curFix.from];
      delete this.validationObj[curFix.from];
    }

    // Use validation object to initialize result object
    var tempResultObj = new Object(),
      fieldIndex = -1;
    for (var name in this.validationObj) {
      var objInstance = $("[name='" + name + "']", this.node).mogo();
      fieldIndex++;

      // Add to result object
      var position = $(objInstance.containerDiv).offset();
      var tempObj = new Object();
      tempObj['instance'] = objInstance;
      tempObj['position'] = new Object();
      tempObj['position']['X'] = position.left;
      tempObj['position']['Y'] = position.top;
      tempObj['result'] = true;
      tempObj['resultDetails'] = '';

      if (objInstance.declaredClass != null) {
        var temp = name;
        if (objInstance.groupElements != null) {
          for (var i = 0; i < objInstance.groupElements.length; i++) {
            $(objInstance.groupElements[i]).on(
              'focus',
              $.proxy(this._onFieldFocus, this, temp, fieldIndex)
            );
            $(objInstance.groupElements[i]).on('blur', $.proxy(this._onFieldBlur, this, temp));
            $(objInstance.groupElements[i]).on('change', $.proxy(this._reValidate, this, temp));
          }
        } else if (
          objInstance.groupInstance != null &&
          objInstance.groupInstance.groupElements != null
        ) {
          for (var i = 0; i < objInstance.groupInstance.groupElements.length; i++) {
            $(objInstance.groupInstance.groupElements[i]).on(
              'focus',
              $.proxy(this._onFieldFocus, this, temp, fieldIndex)
            );
            $(objInstance.groupInstance.groupElements[i]).on(
              'blur',
              $.proxy(this._onFieldBlur, this, temp)
            );
            $(objInstance.groupInstance.groupElements[i]).on(
              'change',
              $.proxy(this._reValidate, this, temp)
            );
          }
        } else if (objInstance.declaredClass == 'Select') {
          $(objInstance.containerDiv).on(
            'enter',
            $.proxy(this._onFieldFocus, this, temp, fieldIndex)
          );
          $(objInstance.containerDiv).on('leave', $.proxy(this._onFieldBlur, this, temp));
          $(objInstance.node).on('focus', $.proxy(this._onFieldFocus, this, temp, fieldIndex));
          $(objInstance.node).on('blur', $.proxy(this._onFieldBlur, this, temp));
          $(objInstance.node).on('change', $.proxy(this._reValidate, this, temp));
        } else {
          $(objInstance.node).on('focus', $.proxy(this._onFieldFocus, this, temp, fieldIndex));
          $(objInstance.node).on('blur', $.proxy(this._onFieldBlur, this, temp));
          $(objInstance.node).on('change', $.proxy(this._reValidate, this, temp));
        }
      }

      // Add to result obj
      tempResultObj[name] = tempObj;
    }
    this._resultObj['resultObj'] = tempResultObj;
  };

  /*
        Shows field error and updates field status in resultObj
    */
  this._showFieldError = function (errorFieldName) {
    var field = $("[name='" + errorFieldName + "'][type!='hidden']")[0];
    if (field == null) return null;

    if (
      field.type != null &&
      (field.type.toLowerCase() == 'checkbox' || field.type.toLowerCase() == 'radio')
    ) {
      if ($(field).mogo().groupInstance != null) {
        $(field)
          .mogo()
          .groupInstance.showError();
        var id = $(field).mogo().id;
        var groupId = $(field).mogo().groupInstance.id;
        if (this._resultObj.resultObj[id]) {
          this._resultObj.resultObj[id].result = false;
        } else if (this._resultObj.resultObj[groupId]) {
          this._resultObj.resultObj[groupId].result = false;
        }
      } else {
        $(field)
          .mogo()
          .showError();
        var name = $(field).attr('name');
        if (this._resultObj.resultObj[name]) {
          this._resultObj.resultObj[name].result = false;
        } else if (this._resultObj.resultObj[$(field).mogo().id]) {
          this._resultObj.resultObj[$(field).mogo().id].result = false;
        }
      }
    } else {
      $(field)
        .mogo()
        .showError();
      var name = $(field).attr('name');
      if (this._resultObj.resultObj[name]) {
        this._resultObj.resultObj[name].result = false;
      } else if (this._resultObj.resultObj[$(field).mogo().id]) {
        this._resultObj.resultObj[$(field).mogo().id].result = false;
      }
    }
  };

  this._reValidate = function (nodeId) {
    var name = nodeId;
    var previouslyValidated = false;
    if (this._resultObj.currentError != null) {
      this._resultObj.resultObj[this._resultObj.currentError].instance.hideErrorLabel();
      this._resultObj.currentError = null;
      previouslyValidated = true;
    }

    if (!$("[name='" + name + "']", this.node).length == 0) {
      this._runValidationForField(name);
    }
    // if (previouslyValidated)
    this._refreshErrorObj();

    for (var key in this._resultObj.resultObj) {
      var obj = this._resultObj.resultObj[key];
      this._toggleErrorState(obj);
    }

    this.onUpdateValidation(this.id, this._resultObj);
  };

  this._runValidationForField = function (name) {
    var validator = new Validator.Validator();
    var value = '';
    if ($("[name='" + name + "']", this.node).mogo().declaredClass == 'Checkbox') {
      value = $("[name='" + name + "']", this.node).mogo().checked;
    } else if ($("[name='" + name + "']", this.node).mogo().declaredClass == 'Radio') {
      if ($("[name='" + name + "']", this.node).mogo().groupInstance) {
        value = $("[name='" + name + "']", this.node)
          .mogo()
          .groupInstance.val();
      } else {
        value = $("[name='" + name + "']", this.node)
          .mogo()
          .val();
      }
    } else {
      value = $("[name='" + name + "']", this.node)
        .mogo()
        .val();
    }

    // Reset error details
    if (this._resultObj.resultObj[name].errorDetails != null) {
      delete this._resultObj.resultObj[name].errorDetails;
    }

    // New format
    if (this.validationObj[name].assertions) {
      var assertions = this.validationObj[name].assertions;
      for (var i = 0; i < assertions.length; i++) {
        var assertion = assertions[i];

        var constraints = new Object();
        var obj = new Object();
        obj[name] = value;

        // Sanitize
        if (typeof assertion.sanitize === 'function') obj[name] = assertion.sanitize(obj[name]);
        else if (
          assertion.sanitize === undefined &&
          typeof this.validationObj[name].sanitize === 'function'
        ) {
          obj[name] = this.validationObj[name].sanitize(obj[name]);
        }

        // Conditional
        var conditional = true;
        if (typeof assertion.conditional === 'function') conditional = assertion.conditional();
        else if (
          assertion.conditional === undefined &&
          typeof this.validationObj[name].conditional === 'function'
        ) {
          conditional = this.validationObj[name].conditional();
        }

        if (conditional) {
          // Assert
          constraints[name] = assertion.assertion;

          var result = validator.validate(obj, constraints);
          if (result !== true) {
            this._resultObj.resultObj[name].result = false;
            this._resultObj.resultObj[name].resultDetails = result;

            // Assign errors
            if (assertion.error != null) {
              if (typeof assertion.error === 'string') {
                this._resultObj.resultObj[name].errorDetails = assertion.error;
              } else if (typeof assertion.error === 'object') {
                this._resultObj.resultObj[name].errorDetails =
                  assertion.error[Object.keys(assertion.error)[0]];
              }
            } else if (this.validationObj[name].error != null) {
              if (typeof this.validationObj[name].error === 'string') {
                this._resultObj.resultObj[name].errorDetails = this.validationObj[name].error;
              } else if (typeof this.validationObj[name].error === 'object') {
                if (this.validationObj[name].error.default != null) {
                  this._resultObj.resultObj[name].errorDetails = this.validationObj[
                    name
                  ].error.default;
                }
              }
            }

            // Stop going through rest of assertion in current object
            break;
          } else if (result == true && i == assertions.length - 1) {
            this._resultObj.resultObj[name].result = true;

            if (this._resultObj.resultObj[name].errorDetails != null) {
              delete this._resultObj.resultObj[name].errorDetails;
            }
          }
        } else {
          if (this._resultObj.resultObj[name].errorDetails != null) {
            delete this._resultObj.resultObj[name].errorDetails;
          }
        }
      }
    } else if (this.validationObj[name].assertion) {
      // Old format
      var constraints = new Object();
      var obj = new Object();
      obj[name] = value;

      // Sanitize
      if (typeof this.validationObj[name].sanitize === 'function') {
        obj[name] = this.validationObj[name].sanitize(obj[name]);
      }

      // Conditional
      var conditional = true;
      if (
        this.validationObj[name].conditional != undefined &&
        typeof this.validationObj[name].conditional === 'function'
      ) {
        conditional = this.validationObj[name].conditional();
      }

      if (conditional) {
        // Assert
        constraints[name] = this.validationObj[name].assertion;

        var result = validator.validate(obj, constraints);
        if (result == true) {
          this._resultObj.resultObj[name].result = true;

          if (this._resultObj.resultObj[name].errorDetails != null) {
            delete this._resultObj.resultObj[name].errorDetails;
          }
        } else {
          this._resultObj.resultObj[name].result = false;
          this._resultObj.resultObj[name].resultDetails = result;

          if (this.validationObj[name].error != null) {
            if (typeof this.validationObj[name].error === 'string') {
              this._resultObj.resultObj[name].errorDetails = this.validationObj[name].error;
            } else if (typeof this.validationObj[name].error === 'object') {
              if (this.validationObj[name].error.default != null) {
                this._resultObj.resultObj[name].errorDetails = this.validationObj[
                  name
                ].error.default;
              } else {
                this._resultObj.resultObj[name].errorDetails = this.validationObj[name].error[
                  Object.keys(this.validationObj[name].error)[0]
                ];
              }
            }
          }
        }
      } else {
        this._resultObj.resultObj[name].result = true;

        if (this._resultObj.resultObj[name].errorDetails != null) {
          delete this._resultObj.resultObj[name].errorDetails;
        }
      }
    }

    // Metadata
    var position = $($("[name='" + name + "']", this.node).mogo().containerDiv).offset();
    this._resultObj.resultObj[name].position.X = position.left;
    this._resultObj.resultObj[name].position.Y = position.top;
  };

  this._toggleErrorState = function (result) {
    var objInstance = result.instance;
    if (result.result == true) {
      if (objInstance.declaredClass == 'Radio' || objInstance.declaredClass == 'Checkbox') {
        objInstance.groupInstance.hideError();
      } else {
        objInstance.hideError();
      }
      return true;
    } else {
      if (objInstance.declaredClass == 'Radio' || objInstance.declaredClass == 'Checkbox') {
        // Set error
        if (result.errorDetails) {
          objInstance.groupInstance.setError(true, result.errorDetails);
        } else {
          objInstance.groupInstance.setError(true);
        }

        objInstance.groupInstance.showError();
        objInstance.groupInstance.hideErrorLabel();
      } else {
        // Set error
        if (result.errorDetails) {
          objInstance.setError(true, result.errorDetails);
        } else {
          objInstance.setError(true);
        }

        objInstance.showError();
        objInstance.hideErrorLabel();
      }
      return false;
    }
  };

  /*
        Updates resultObj error count and current error node
    */

  this._refreshErrorObj = function (enableAnalytics) {
    this._resultObj.count = 0;
    var tempArr = new Array(),
      errorFieldList = []; // DL - Keeps the list of fields with error on each submit

    for (var key in this._resultObj.resultObj) {
      if (!this._resultObj.resultObj[key].result) {
        this._resultObj.count++;
        tempArr.push(this._resultObj.resultObj[key]);

        // DL - List of error fields format:
        // '<field name>, <field name>,...'
        errorFieldList.push(key);
      }
    }

    if (this._resultObj.count > 0) {
      tempArr.sort(function (a, b) {
        if (a.position.Y == b.position.Y) return a.position.X - b.position.X;
        return a.position.Y - b.position.Y;
      });
      this._resultObj.currentError = $(tempArr[0].instance.node).attr('name');

      /* In some cases, we need to push error again even if the last pushed error was the same. For example;
            1. Fill a field with invalid data. On change, field errors. Analytics data is pushed.
            2. Go back to the field, fix error. Fill another field. Go back to the previous field and input invalid data.
            If we use just pushEvent instead of forcePushEvent, error condition mentioned above won't be pushed.
             */
      if (typeof enableAnalytics !== 'undefined' && enableAnalytics === false) {
        return;
      }
      this.analytics.forcePushEvent('form-errors', {FormErrors: [errorFieldList.join(',')]});
    } else {
      this._resultObj.currentError = null;
    }
  };

  this._ERROR_LABEL_HEIGHT = 270;
  this._$html = $('html');
  this._$body = $('body');
  this._$tray = $('.portal__tray');
  this._$content = $('.portal__content');

  this._scrollTo = function (name) {
    var $elem = $("[name='" + name + "']", this.node);
    if ($elem.length === 0) return;

    this._scrollToElement($elem);
  };

  this._getScrollSpeed = function (elemPos) {
    var time = 500;
    var submitButton = $("input[type='submit'], button[type='submit']", this.node);
    if (submitButton.length === 1) {
      var difference = submitButton.offset().top - elemPos;
      time = difference * 0.65;
    }
    return time;
  };

  this._showErrorLabelForElement = function ($elem) {
    if (this._isMogoUIComponent($elem[0])) {
      $elem.mogo().showErrorLabel();
    }
  };

  this._scrollToElement = function ($elem, elemPos, time) {
    var htmlScrollTop = this._$html.scrollTop(); // mobile
    var bodyScrollTop = this._$body.scrollTop(); // mobile safari
    var trayScrollTop = this._$tray.scrollTop(); // tray visbile
    var contentScrollTop = this._$content.scrollTop();

    var scrollTop = htmlScrollTop;
    var scrollSelector = 'html';
    var elemPos = $elem.offset().top - this._ERROR_LABEL_HEIGHT;
    var position = elemPos;
    if (bodyScrollTop) {
      scrollSelector = 'body';
      scrollTop = bodyScrollTop;
    } else if (trayScrollTop) {
      scrollSelector = '.portal__tray';
      scrollTop = trayScrollTop;
      position += scrollTop;
    } else if (contentScrollTop) {
      scrollSelector = '.portal__content';
      scrollTop = contentScrollTop;
      position += scrollTop;
    }

    if (scrollTop <= elemPos) {
      // already visbile
      this._showErrorLabelForElement($elem);
      return;
    }

    $(scrollSelector).animate(
      {scrollTop: position + 'px'},
      {
        duration: this._getScrollSpeed(elemPos),
        complete: this._showErrorLabelForElement.bind(this, $elem)
      }
    );
  };

  this._isMogoUIComponent = function (field) {
    if (field == null) return false;

    if (typeof field === 'string' && $("[name='" + field + "']", this.node).length > 0) {
      return typeof $("[name='" + field + "']", this.node).mogo().create !== 'function';
    } else {
      if (field instanceof HTMLElement && typeof $(field).mogo().create !== 'function') {
        return true;
      } else if (
        field instanceof jQuery &&
        field.length == 1 &&
        typeof $(field[0]).mogo().create !== 'function'
      ) {
        return true;
      } else if (typeof field.create !== 'function' && field.declaredClass) {
        return true;
      }
    }
    return false;
  };

  this._onFieldFocus = function (name, fieldIndex) {
    // DL array of fields
    this.dlAbandonedFields.push([fieldIndex, name]);

    if (name == null || name == '') return;

    if (this._resultObj.currentError != null) {
      if (name != this._resultObj.currentError) {
        var elem = this._resultObj.resultObj[name].instance;
        if (
          elem.declaredClass == 'Checkbox' ||
          elem.declaredClass == 'Radio' ||
          elem.declaredClass == 'BooleanGroup'
        ) {
          setTimeout(
            $.proxy(
              function (elem) {
                if (elem._state < 0) {
                  for (var key in this._resultObj.resultObj) {
                    this._resultObj.resultObj[key].instance.hideErrorLabel();
                  }
                  elem.showErrorLabel();
                }
              },
              this,
              elem
            ),
            200
          );
        } else {
          if (elem._state < 0) {
            for (var key in this._resultObj.resultObj) {
              this._resultObj.resultObj[key].instance.hideErrorLabel();
            }
            elem.showErrorLabel();
          }
        }
      } else {
        var elem = $("[name='" + name + "']", this.node).mogo();
        if (
          elem.declaredClass == 'Checkbox' ||
          elem.declaredClass == 'Radio' ||
          elem.declaredClass == 'BooleanGroup'
        ) {
          setTimeout(
            $.proxy(function (elem) {
              if (elem._state == -1) elem.showErrorLabel();
            }, this),
            200,
            elem
          );
        } else {
          elem.showErrorLabel();
        }
      }
    } else {
      var elem = this._resultObj.resultObj[name].instance;
      if (
        elem.declaredClass == 'Checkbox' ||
        elem.declaredClass == 'Radio' ||
        elem.declaredClass == 'BooleanGroup'
      ) {
        setTimeout(
          $.proxy(
            function (elem) {
              if (elem._state == -1) elem.showErrorLabel();
            },
            this,
            elem
          ),
          200
        );
      } else {
        if (elem._state == -1) elem.showErrorLabel();
      }
    }
  };

  this._onFieldBlur = function (name) {
    if (name == null || name == '') return;

    if (this._resultObj.currentError != null) {
      if (name != this._resultObj.currentError) {
        this._resultObj.resultObj[name].instance.hideErrorLabel();
      }
      setTimeout(
        $.proxy(function () {
          var elem = document.activeElement;
          if (elem.id) {
            if ($(elem).mogo().create || !$(elem).mogo().extends) {
              this._resultObj.resultObj[this._resultObj.currentError].instance.showErrorLabel();
            } else {
              var extendsInput = false;
              for (var i = 0; i < $(elem).mogo().extends.length; i++) {
                if ($(elem).mogo().extends[i] == '_Input') {
                  extendsInput = true;
                  break;
                }
              }
              if (extendsInput) {
                if ($(elem).mogo()._state != -1) {
                  if (this._resultObj.currentError != null) {
                    this._resultObj.resultObj[
                      this._resultObj.currentError
                    ].instance.showErrorLabel();
                  }
                }
              } else {
                this._resultObj.resultObj[this._resultObj.currentError].instance.showErrorLabel();
              }
            }
          } else {
            if (
              $(elem)
                .parents()
                .filter('[class*=mogo-ui-]')
            ) {
              var temp = $(elem)
                .parents()
                .filter('[class*=mogo-ui-]')[0];
              if ($('[data-mogo-ui]', temp).length > 0) {
                var mogoElem = $($('[data-mogo-ui]', temp)[0]).mogo();
                if (mogoElem.extends) {
                  var extendsInput = false;
                  for (var i = 0; i < mogoElem.extends.length; i++) {
                    if (mogoElem.extends[i] == '_Input') {
                      extendsInput = true;
                      break;
                    }
                  }
                  if (extendsInput) {
                    if (mogoElem._state == -1) {
                      return;
                    }
                  }
                }
              }
            }
            this._resultObj.resultObj[this._resultObj.currentError].instance.showErrorLabel();
          }
        }, this),
        225
      );
    } else {
      var elem = this._resultObj.resultObj[name].instance;
      if (elem._state == -1) elem.hideErrorLabel();
    }
  };

  this._onFormAbandonment = function () {
    var self = this;
    if (
      !(self._resultObj.submitted && self._resultObj.count === 0) &&
      self.dlAbandonedFields.length > 0
    ) {
      var orderedIndex = self.dlAbandonedFields,
        distinctFields = self.distinctArray(orderedIndex),
        sortedFields = distinctFields.sort(function (a, b) {
          // return positive value if a should come after b
          return a[0] - b[0];
        }),
        orderedFields = jQuery.map(sortedFields, function (a) {
          return a[1];
        });

      this.analytics.pushEvent('form-abandoned', {
        FormAbandoned: [orderedFields.join(',')]
      });
      self.dlAbandonedFields = [];
    }
  };

  this.destroy = function () {
    $(window).off('beforeunload.validation');
    this._onFormAbandonment();
  };
}
